// Import các module cần thiết
import { Voip24hModule, EventSipGateway } from './src/voip24h_module.js';
import { initCanvasBackground } from './src/background.js';

let voip24hModuleInstance;

// === KHAI BÁO BIẾN DOM VÀ BIẾN TOÀN CỤC ===
let logContainer, logOutput, phoneNumberField, statusDiv, tokenStatusDiv, hangupStatusDiv, mainContentContainer, tokenEntryContainer, ipRestrictionMessageDiv, callButton, hangupButton, extensionDisplay, controlExtensionDisplay, tokenInput, appLogo, appContainer, callControlContainer, contactListContainer, tokenEntryVersionSpan, callControlVersionSpan, appVersionSpan, contactsVersionSpan, peerStatusVersionSpan, tokenEntrySupportPhoneSpan, tokenEntrySupportNameSpan, callControlSupportPhoneSpan, callControlSupportNameSpan, appSupportPhoneSpan, appSupportNameSpan, contactsSupportPhoneSpan, contactsSupportNameSpan, peerStatusSupportPhoneSpan, peerStatusSupportNameSpan, webrtcCallPopup, callPopupTime, callPopupAvatar, callPopupName, callPopupNumber, callPopupTimer, webrtcSpeakerButton, webrtcKeypadButton, webrtcMuteButton, webrtcHoldButton, webrtcAnswerButton, webrtcDeclineButton, webrtcHangupButton, webRtcCallButton, tokenSubmitButton, callPopupStatus;
let peerStatusList, peerStatusInterval = null, peerStatusTimestamp;
// Biến DOM cho Zalo
let zaloMessagesContainer, zaloMessageList, openZaloBtn, closeZaloBtn, zaloVersionSpan, zaloSupportPhoneSpan, zaloSupportNameSpan, zaloNotificationModal, zaloModalConfirmBtn;


// === CÁC BIẾN TRẠNG THÁI VÀ CẤU HÌNH ===
const nonNumericInputErrorMsg = 'Chỉ hỗ trợ nhập số. Vui lòng không nhập chữ hoặc ký tự.';
let statusClearTimer = null;
let currentActiveExtension = null;
let currentEmployeeName = null;
let currentSipPassword = null;
let currentAppVersion = 'Đang tải...';
let currentSupportPhone = 'Đang tải...';
let currentSupportPersonName = 'Đang tải...';
const SAVED_TOKEN_KEY = 'gasLongHoaSavedExtensionToken';
let savedActualToken = null;
let ipCheckIntervalId = null;
let fastIpCheckIntervalId = null;
let isAttemptingAutoLogin = false;
let isSipRegistered = false;
let isCallActive = false;
let isProcessingAction = false; 
let latestPeerStatusData = [];
let lastPeerStatusTimestamp = null;
const WORKER_BASE_URL = 'https://wktest.minhduy4545.workers.dev';
const PHONE_RINGING_SOUND_URL = 'https://github.com/minh-duy-hoang/gaslonghoa-assets/raw/refs/heads/main/Nh%E1%BA%A1c%20chu%C3%B4ng%20cu%E1%BB%99c%20g%E1%BB%8Di%20%C4%91%E1%BA%BFn%20con%20g%E1%BA%A5u.mp3';
const HANGUP_SOUND_URL = "https://github.com/minh-duy-hoang/gaslonghoa-assets/raw/refs/heads/main/Am%20thanh%20ket%20thuc%20cuoc%20goi.mp3";
let currentAudio = null;
let callTimerInterval = null;
let callStartTime = 0;
let dynamicContacts = [];
let forwardingExtensions = [];
let workerConnectionFailures = 0;
const MAX_CONNECTION_FAILURES = 3;
let networkCheckInterval = null;
let isFirstTransferModalRender = true;
const SECRET_KEY = "minh-duy-hoang-nguyen-gaslonghoa-secret-key-16-06-2025-19-17-10";
// Biến cho Zalo
const ZALO_ALERT_SOUND_URL = 'https://github.com/minh-duy-hoang/gaslonghoa-assets/raw/refs/heads/main/Am%20thanh%20canh%20bao%20khi%20co%20tin%20nhan%20zalo.mp3'; // Âm thanh báo thức mới
let zaloAlertAudio = null;
let isZaloAlertPlaying = false;
let wasZaloAlertPausedForCall = false;


// === BIẾN TRẠNG THÁI CUỘC GỌI THỜI GIAN THỰC ===
let activeCallStates = {}; 

function xorCipher(str, key) {
    let output = '';
    for (let i = 0; i < str.length; i++) {
        output += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return output;
}


// === CÁC HÀM TRỢ GIÚP (HELPER FUNCTIONS) ===

function appendLog(message) {
    if (logOutput) {
        const now = new Date();
        logOutput.textContent += `[${now.toLocaleTimeString()}] ${message}\n`;
        logOutput.scrollTop = logOutput.scrollHeight;
    } else {
        console.log(`[Pending Log - Console Only] ${message}`);
    }
}

async function pickupCall(extensionIn) {
    appendLog(`Đang yêu cầu rước cuộc gọi cho máy nhánh: ${extensionIn}`);
    if (!savedActualToken || !currentActiveExtension) {
        displayStatus('Lỗi: Không tìm thấy token hoặc máy nhánh hiện tại. Vui lòng đăng nhập lại.', 'error', 5000, statusDiv);
        return;
    }

    if (extensionIn === currentActiveExtension) {
        displayStatus('Bạn không thể tự rước máy của chính mình.', 'error', 3000, statusDiv);
        return;
    }

    const pickupButton = document.querySelector(`.pickup-btn[data-extension-in="${extensionIn}"]`);
    if (pickupButton) {
        pickupButton.disabled = true;
        pickupButton.innerHTML = `<span>Đang rước...</span>`;
    }
    
    const workerPickupUrl = `${WORKER_BASE_URL}/pickup`;
    const formData = new URLSearchParams({
        token: savedActualToken,
        extensionIn: extensionIn
    });

    try {
        const response = await fetch(workerPickupUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });

        const responseData = await response.json();
        appendLog(`Pickup worker response: ${response.status}, data: ${JSON.stringify(responseData)}`);

        if (response.ok && responseData.status) {
            displayStatus(`Đã gửi yêu cầu rước máy ${extensionIn} thành công!`, 'success', 5000, statusDiv);
        } else {
            displayStatus(`Lỗi khi rước máy: ${responseData.message || 'Không thể thực hiện'}`, 'error', 7000, statusDiv);
            if (pickupButton) {
                pickupButton.disabled = false;
                renderPeerStatus(latestPeerStatusData);
            }
        }
    } catch (error) {
        appendLog(`Error during pickup fetch: ${error}`);
        displayStatus('Lỗi kết nối đến dịch vụ rước máy.', 'error', 7000, statusDiv);
        if (pickupButton) {
            pickupButton.disabled = false;
            renderPeerStatus(latestPeerStatusData);
        }
    }
}

function renderPeerStatus(peers) {
    if (!peerStatusList) return;

    const peerStatusContainer = document.getElementById('peer-status-container');
    const summaryContainer = document.getElementById('peer-status-summary');

    if (!peers || peers.length === 0) {
        if (peerStatusContainer) peerStatusContainer.style.display = 'none';
        return;
    }
    
    if (peerStatusContainer) peerStatusContainer.style.display = 'block';
    
    peerStatusList.innerHTML = '';
    let onlineCount = 0;
    let busyCount = 0;

    peers.forEach(peer => {
        const peerExtension = peer.extension;
        const statusMessage = peer.statusData?.data?.messageExt;
        const isOnline = statusMessage === 'online';
        if (isOnline) onlineCount++;

        const isBusy = !!activeCallStates[peerExtension];
        if (isBusy) busyCount++;
        
        const statusClass = isOnline ? 'online' : 'offline';
        const statusTitle = isOnline ? 'Online' : `Offline (${statusMessage || 'N/A'})`;

        const peerElement = document.createElement('div');
        peerElement.className = 'peer-item';
        
        const mainInfoContainer = document.createElement('div');
        mainInfoContainer.style.display = 'flex';
        mainInfoContainer.style.alignItems = 'center';
        mainInfoContainer.style.flexGrow = '1';

        mainInfoContainer.innerHTML = `
            <span class="status-dot ${statusClass}" title="${statusTitle}"></span>
            <div class="peer-info">
                <div class="peer-name">${peer.name}</div>
                <div class="peer-extension">Máy nhánh: ${peer.extension}</div>
            </div>
        `;
        peerElement.appendChild(mainInfoContainer);

        const callState = activeCallStates[peerExtension];
        if (callState) {
            peerElement.classList.add(callState.status);
            const peerName = latestPeerStatusData.find(p => p.extension === callState.peer)?.name || callState.peer;
            if (callState.status === 'ringing') {
                peerElement.title = `Đang nhận cuộc gọi từ: ${peerName} (${callState.peer})`;
                if (peerExtension !== currentActiveExtension) {
                    const pickupButton = document.createElement('button');
                    pickupButton.className = 'pickup-btn';
                    pickupButton.dataset.extensionIn = peerExtension;
                    pickupButton.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <span>Rước Máy</span>
                    `;
                    pickupButton.onclick = (e) => {
                        e.stopPropagation();
                        pickupCall(peerExtension);
                    };
                    peerElement.appendChild(pickupButton);
                }
            } else if (callState.status === 'in-call') {
                peerElement.title = `Đang trong cuộc gọi với: ${peerName} (${callState.peer})`;
            } else if (callState.status === 'calling-out') {
                peerElement.title = `Đang gọi đi đến: ${peerName} (${callState.peer})`;
            }
        }
        
        peerStatusList.appendChild(peerElement);
    });
    
    if (summaryContainer) {
        summaryContainer.innerHTML = `
            <div class="summary-item">
                <span class="count count-total">${peers.length}</span>
                <span class="label">Tổng</span>
            </div>
            <div class="summary-item">
                <span class="count count-online">${onlineCount}</span>
                <span class="label">Online</span>
            </div>
            <div class="summary-item">
                <span class="count count-busy">${busyCount}</span>
                <span class="label">Đang bận</span>
            </div>
            <div class="summary-item">
                <span class="count count-offline">${peers.length - onlineCount}</span>
                <span class="label">Offline</span>
            </div>
        `;
    }

    if (peerStatusTimestamp) {
        const now = lastPeerStatusTimestamp || new Date();
        const formattedTime = now.toLocaleString('vi-VN', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
        peerStatusTimestamp.textContent = `Cập nhật lần cuối: ${formattedTime}`;
    }
}

async function fetchAndRenderPeerStatus() {
    if (!savedActualToken) {
        if (peerStatusInterval) clearInterval(peerStatusInterval);
        return;
    }
    try {
        const response = await fetch(`${WORKER_BASE_URL}/get-peer-status`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ token: savedActualToken })
        });

        if (response.ok) {
            const peersData = await response.json();
            
            latestPeerStatusData = peersData;
            lastPeerStatusTimestamp = new Date();
            
            renderPeerStatus(peersData);

            const transferModal = document.getElementById('transfer-modal');
            if (transferModal && transferModal.style.display === 'flex') {
                renderTransferModalList(false);
            }

            if (Array.isArray(peersData) && peersData.length === 0) {
                const peerStatusContainer = document.getElementById('peer-status-container');
                if (peerStatusContainer) {
                    peerStatusContainer.style.display = 'none';
                }
            }

        } else {
            console.error("Lỗi khi lấy trạng thái máy nhánh:", response.status);
            if (response.status === 401 || response.status === 403 || response.status >= 500) {
                if (peerStatusInterval) clearInterval(peerStatusInterval);
                const peerStatusContainer = document.getElementById('peer-status-container');
                if (peerStatusContainer) peerStatusContainer.style.display = 'none';
            }
        }
    } catch (error) {
        console.error("Lỗi mạng khi lấy trạng thái máy nhánh:", error);
    }
}


async function fetchContactList() {
    if (!savedActualToken) {
        appendLog("Không có token, không thể lấy danh bạ.");
        return;
    }
    try {
        const contactsUrl = `${WORKER_BASE_URL}/get-contacts`;
        const formData = new URLSearchParams({ token: savedActualToken });
        const response = await fetch(contactsUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });
        if (response.ok) {
            const data = await response.json();
            dynamicContacts = data;
            appendLog(`Đã tải thành công ${dynamicContacts.length} liên hệ từ server.`);
        } else {
            appendLog(`Lỗi khi tải danh bạ: ${response.status}`);
            dynamicContacts = [];
        }
    } catch (error) {
        appendLog(`Lỗi mạng khi tải danh bạ: ${error}`);
        dynamicContacts = [];
    }
}


async function fetchForwardingExtensions() {
    if (!savedActualToken) {
        appendLog("Không có token, không thể lấy danh sách máy nhánh chuyển tiếp.");
        return;
    }
    try {
        const extensionsUrl = `${WORKER_BASE_URL}/extensions`;
        const formData = new URLSearchParams({ token: savedActualToken });
        const response = await fetch(extensionsUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });
        if (response.ok) {
            const data = await response.json();
            forwardingExtensions = data;
            appendLog(`Đã tải thành công ${forwardingExtensions.length} máy nhánh để chuyển tiếp (tĩnh).`);
        } else {
            appendLog(`Lỗi khi tải danh sách máy nhánh chuyển tiếp: ${response.status}`);
            forwardingExtensions = [];
        }
    } catch (error) {
        appendLog(`Lỗi mạng khi tải danh sách máy nhánh chuyển tiếp: ${error}`);
        forwardingExtensions = [];
    }
}

function unlockAudioContext() {
    const audio = new Audio('data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA');
    audio.volume = 0;
    audio.play().catch(() => {});
    appendLog('Audio context unlock attempted.');
}

function playSound(soundUrl, loop = false) {
    if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
    }
    currentAudio = new Audio(soundUrl);
    currentAudio.loop = loop;
    currentAudio.play().catch(e => {
        console.error("Lỗi không thể phát âm thanh:", e);
        if (e.name === 'NotAllowedError') {
            displayStatus('Lỗi âm thanh: Vui lòng click vào trang để cho phép phát nhạc chuông.', 'error', 5000);
        }
    });
}

function stopSound() {
    if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        currentAudio = null;
    }
}

function startCallTimer() {
    callStartTime = Date.now();
    callTimerInterval = setInterval(() => {
        const elapsed = Date.now() - callStartTime;
        const minutes = Math.floor(elapsed / (1000 * 60));
        const seconds = Math.floor((elapsed % (1000 * 60)) / 1000);
        if (callPopupTimer) callPopupTimer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }, 1000);
}

function stopCallTimer() {
    clearInterval(callTimerInterval);
    if (callPopupTimer) callPopupTimer.textContent = '00:00';
}

function formatPhoneNumber(phone) {
    if (!phone) return '';
    if (phone.length === 10 && phone.startsWith('0')) {
        return `${phone.substring(0,4)}.${phone.substring(4,7)}.${phone.substring(7)}`;
    } else if (phone.length === 11 && phone.startsWith('0')) {
        return `${phone.substring(0,4)}.${phone.substring(4,8)}.${phone.substring(8)}`;
    }
    return phone;
}

function updateVersionDisplay(version) {
    if (tokenEntryVersionSpan) tokenEntryVersionSpan.textContent = version;
    if (callControlVersionSpan) callControlVersionSpan.textContent = version;
    if (appVersionSpan) appVersionSpan.textContent = version;
    if (zaloVersionSpan) zaloVersionSpan.textContent = version;
    if (contactsVersionSpan) contactsVersionSpan.textContent = version;
    if (peerStatusVersionSpan) peerStatusVersionSpan.textContent = version;
    currentAppVersion = version;
}

function updateSupportInfoDisplay(phone, name) {
    currentSupportPhone = phone;
    currentSupportPersonName = name;
    const formattedPhone = formatPhoneNumber(phone);
    if (tokenEntrySupportPhoneSpan) { tokenEntrySupportPhoneSpan.textContent = formattedPhone; tokenEntrySupportPhoneSpan.href = `tel:${phone}`; }
    if (tokenEntrySupportNameSpan) tokenEntrySupportNameSpan.textContent = name;
    if (callControlSupportPhoneSpan) { callControlSupportPhoneSpan.textContent = formattedPhone; callControlSupportPhoneSpan.href = `tel:${phone}`; }
    if (callControlSupportNameSpan) callControlSupportNameSpan.textContent = name;
    if (appSupportPhoneSpan) { appSupportPhoneSpan.textContent = formattedPhone; appSupportPhoneSpan.onclick = () => phoneNumberField.value = phone; }
    if (appSupportNameSpan) appSupportNameSpan.textContent = name;
    if (contactsSupportPhoneSpan) { contactsSupportPhoneSpan.textContent = formattedPhone; contactsSupportPhoneSpan.onclick = () => phoneNumberField.value = phone; }
    if (contactsSupportNameSpan) contactsSupportNameSpan.textContent = name;
    if (peerStatusSupportPhoneSpan) { peerStatusSupportPhoneSpan.textContent = formattedPhone; peerStatusSupportPhoneSpan.href = `tel:${phone}`; }
    if (peerStatusSupportNameSpan) peerStatusSupportNameSpan.textContent = name;
    if (zaloSupportPhoneSpan) { zaloSupportPhoneSpan.textContent = formattedPhone; zaloSupportPhoneSpan.href = `tel:${phone}`; }
    if (zaloSupportNameSpan) zaloSupportNameSpan.textContent = name;
}


function renderContactList() {
    const contactsDiv = document.getElementById('contacts');
    if (!contactsDiv) return;

    contactsDiv.innerHTML = '';

    if (dynamicContacts.length === 0) {
        contactsDiv.innerHTML = '<p class="empty-list-message">Không có danh bạ hoặc không thể tải.</p>';
        return;
    }

    dynamicContacts.forEach(contact => {
        const validExt = contact.ext?.filter(e => e) || [];
        const validMobile = contact.mobile?.filter(m => m) || [];
        const totalNumbers = validExt.length + validMobile.length;

        if (totalNumbers === 0) return;

        if (totalNumbers === 1) {
            const singleNumber = validExt[0] || validMobile[0];
            const contactItem = document.createElement('div');
            contactItem.className = 'contact-item';
            contactItem.innerHTML = `
                <img src="${contact.avatar}" alt="Avatar" class="contact-avatar" onerror="this.src='https://i.pravatar.cc/150?u=${singleNumber}'">
                <span class="contact-name">${contact.name}</span>
            `;
            contactItem.style.cursor = 'pointer';
            contactItem.onclick = () => {
                if (phoneNumberField) {
                    phoneNumberField.value = singleNumber;
                    if (window.innerWidth < 800) { showAppView(); }
                    displayStatus(`Đã chọn số <span class="phone-highlight">${singleNumber}</span>. Sẵn sàng gọi.`, '', 3000);
                }
            };
            contactsDiv.appendChild(contactItem);
        } else {
            const contactGroup = document.createElement('div');
            contactGroup.className = 'contact-group';

            const mainContactElement = document.createElement('div');
            mainContactElement.className = 'contact-item expandable';
            mainContactElement.innerHTML = `
                <img src="${contact.avatar}" alt="Avatar" class="contact-avatar" onerror="this.src='https://i.pravatar.cc/150?u=${contact.name}'">
                <span class="contact-name">${contact.name}</span>
                <div class="expand-icon">
                    <svg viewBox="0 0 24 24">
                        <path class="vert" d="M12 5V19" />
                        <path class="horz" d="M5 12H19" />
                    </svg>
                </div>
            `;

            const subList = document.createElement('div');
            subList.className = 'sub-contact-list';

            const createSubItemHTML = (number, type) => {
                const icon = type === 'ext' ?
                    'https://api.iconify.design/material-symbols:phone-in-talk.svg' :
                    'https://api.iconify.design/material-symbols:smartphone.svg';
                const label = type === 'ext' ? 'Máy nhánh' : 'Di động';
                return `<div class="sub-contact-item" data-number="${number}">
                            <img src="${icon}" class="sub-contact-icon" alt="${type}">
                            <span>${label}: ${number}</span>
                        </div>`;
            };

            let subListHTML = '';
            validExt.forEach(extNum => subListHTML += createSubItemHTML(extNum, 'ext'));
            validMobile.forEach(mobileNum => subListHTML += createSubItemHTML(mobileNum, 'mobile'));
            subList.innerHTML = subListHTML;

            contactGroup.appendChild(mainContactElement);
            contactGroup.appendChild(subList);

            mainContactElement.onclick = () => {
                contactGroup.classList.toggle('expanded');
            };

            subList.querySelectorAll('.sub-contact-item').forEach((item, index) => {
                item.style.animationDelay = `${index * 0.05}s`;
                item.onclick = (e) => {
                    e.stopPropagation();
                    const numberToCall = item.dataset.number;
                    if (phoneNumberField) {
                        phoneNumberField.value = numberToCall;
                        if (window.innerWidth < 800) { showAppView(); }
                        displayStatus(`Đã chọn số <span class="phone-highlight">${numberToCall}</span>. Sẵn sàng gọi.`, '', 3000);
                    }
                }
            });

            contactsDiv.appendChild(contactGroup);
        }
    });

    if (contactsDiv.childElementCount === 0) {
        contactsDiv.innerHTML = '<p class="empty-list-message">Không có liên hệ nào có số điện thoại.</p>';
    }
}


function showWebRTCCallPopup(callType, callerInfo, direction = 'Outgoing') {
    if (isZaloAlertPlaying) {
        stopZaloAlert();
        wasZaloAlertPausedForCall = true;
        appendLog("Đã tạm dừng âm thanh Zalo do có cuộc gọi.");
    }
    isCallActive = true;
    if (webrtcCallPopup) webrtcCallPopup.style.display = 'flex';
    if (mainContentContainer) mainContentContainer.style.display = 'none';
    if (logContainer) logContainer.style.display = 'none';

    if (callPopupTime) callPopupTime.textContent = new Date().toLocaleTimeString('vi-VN');
    if (callPopupName) callPopupName.textContent = callerInfo.name || callerInfo.phone || 'Unknown';
    if (callPopupNumber) callPopupNumber.textContent = formatPhoneNumber(callerInfo.phone);
    if (callPopupAvatar) {
        callPopupAvatar.src = callerInfo.avatar || `https://i.pravatar.cc/150?u=${callerInfo.phone}`;
        callPopupAvatar.onerror = function() { this.src = 'https://i.pravatar.cc/150?u=default' };
    }

    const networkStatus = document.getElementById('network-status');

    if (callType === 'incoming') {
        if (webrtcSpeakerButton) webrtcSpeakerButton.style.display = 'none';
        if (webrtcKeypadButton) webrtcKeypadButton.style.display = 'none';
        if (webrtcMuteButton) webrtcMuteButton.style.display = 'none';
        if (webrtcHoldButton) webrtcHoldButton.style.display = 'none';
        if(networkStatus) networkStatus.style.display = 'none';

        if (webrtcAnswerButton) webrtcAnswerButton.style.display = 'flex';
        if (webrtcDeclineButton) webrtcDeclineButton.style.display = 'flex';
        if (webrtcHangupButton) webrtcHangupButton.style.display = 'none';

        if (webrtcCallPopup && webrtcCallPopup.querySelector('.call-type')) webrtcCallPopup.querySelector('.call-type').textContent = 'Cuộc gọi đến';
        if (webrtcCallPopup && webrtcCallPopup.querySelector('.call-direction')) webrtcCallPopup.querySelector('.call-direction').textContent = '';
        
        if (callPopupStatus) {
            callPopupStatus.textContent = '';
            callPopupStatus.className = 'call-status';
        }

        playSound(PHONE_RINGING_SOUND_URL, true);
    } else { // Outgoing call
        if (webrtcSpeakerButton) webrtcSpeakerButton.style.display = 'flex';
        if (webrtcKeypadButton) {
            webrtcKeypadButton.style.display = 'flex';
            webrtcKeypadButton.disabled = true; 
            webrtcKeypadButton.style.opacity = '0.5';
            webrtcKeypadButton.style.cursor = 'not-allowed';
            webrtcKeypadButton.title = 'Chức năng sẽ có khi cuộc gọi được kết nối';
        }
        if (webrtcMuteButton) webrtcMuteButton.style.display = 'flex';
        if (webrtcHoldButton) webrtcHoldButton.style.display = 'flex';
        if(networkStatus) networkStatus.style.display = 'flex';

        if (webrtcAnswerButton) webrtcAnswerButton.style.display = 'none';
        if (webrtcDeclineButton) webrtcDeclineButton.style.display = 'none';
        if (webrtcHangupButton) webrtcHangupButton.style.display = 'flex';

        if (webrtcCallPopup && webrtcCallPopup.querySelector('.call-type')) webrtcCallPopup.querySelector('.call-type').textContent = 'Đang gọi';
        if (webrtcCallPopup && webrtcCallPopup.querySelector('.call-direction')) webrtcCallPopup.querySelector('.call-direction').textContent = direction === 'Outgoing' ? 'Gọi đi' : '';
        
        if (callPopupStatus) {
            callPopupStatus.textContent = 'Đang gọi...';
            callPopupStatus.className = 'call-status calling';
        }

        stopSound();
    }
}

function hideWebRTCCallPopup() {
    isCallActive = false;
    if (networkCheckInterval) {
        clearInterval(networkCheckInterval);
        networkCheckInterval = null;
    }

    if (webrtcCallPopup) webrtcCallPopup.style.display = 'none';
    
    // Sửa lỗi màn hình chính không hiện lại
    if (tokenEntryContainer && tokenEntryContainer.style.display === 'none' && ipRestrictionMessageDiv && ipRestrictionMessageDiv.style.display === 'none') {
        if (mainContentContainer) mainContentContainer.style.display = 'flex';
        if (logContainer) logContainer.style.display = 'block';
    }

    stopSound();
    stopCallTimer();
    if (callPopupTimer) callPopupTimer.textContent = '00:00';
    if (callPopupStatus) {
        callPopupStatus.textContent = '';
        callPopupStatus.className = 'call-status';
    }
    if (webrtcMuteButton) {
        webrtcMuteButton.classList.remove('active');
        if (webrtcMuteButton.querySelector('img')) webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic-off.svg';
    }
    if (webrtcHoldButton) {
        webrtcHoldButton.classList.remove('active');
        if (webrtcHoldButton.querySelector('img')) webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:pause.svg';
    }
    if (webrtcKeypadButton) {
        webrtcKeypadButton.disabled = false;
        webrtcKeypadButton.style.opacity = '1';
        webrtcKeypadButton.style.cursor = 'pointer';
        webrtcKeypadButton.title = 'Chuyển tiếp cuộc gọi';
    }

    const modal = document.getElementById('transfer-modal');
    if (modal && modal.style.display === 'flex') {
        modal.classList.remove('show');
        modal.style.display = 'none';
    }

    // Phát lại âm thanh Zalo nếu cần
    if (wasZaloAlertPausedForCall) {
        wasZaloAlertPausedForCall = false; // Reset flag
        const hasUnread = zaloMessageList && zaloMessageList.querySelector('.zalo-message-item.unread');
        if (hasUnread) {
            playZaloAlert();
            appendLog("Đã phát lại âm thanh Zalo sau khi cuộc gọi kết thúc.");
        }
    }
}

function showZaloView() {
    if (window.innerWidth < 800) {
        if(appContainer) appContainer.style.display = 'none';
        if(callControlContainer) callControlContainer.style.display = 'none';
        if(contactListContainer) contactListContainer.style.display = 'none';
        if(zaloMessagesContainer) {
            zaloMessagesContainer.style.display = 'flex';
            zaloMessagesContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}

function showContactsView() {
    if (window.innerWidth < 800) {
        if(appContainer) appContainer.style.display = 'none';
        if(callControlContainer) callControlContainer.style.display = 'none';
        if(zaloMessagesContainer) zaloMessagesContainer.style.display = 'none';
        if(contactListContainer) {
            contactListContainer.style.display = 'block';
            contactListContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}

function showAppView() {
    if (window.innerWidth < 800) {
        if(contactListContainer) contactListContainer.style.display = 'none';
        if(callControlContainer) callControlContainer.style.display = 'none';
        if(zaloMessagesContainer) zaloMessagesContainer.style.display = 'none';
        if(appContainer) {
            appContainer.style.display = 'block';
            appContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}

function showCallControlView() {
    if (window.innerWidth < 800) {
        if(appContainer) appContainer.style.display = 'none';
        if(contactListContainer) contactListContainer.style.display = 'none';
        if(zaloMessagesContainer) zaloMessagesContainer.style.display = 'none';
        if(callControlContainer) {
            callControlContainer.style.display = 'block';
            callControlContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}

function displayStatus(message, type = '', duration = null, targetDiv = statusDiv) {
    if (targetDiv) {
        let contentToShow = message;
        if (targetDiv === statusDiv && message === 'Hệ thống đang trực tuyến. Sẵn sàng gọi.' && type === 'success' && currentActiveExtension && mainContentContainer && mainContentContainer.style.display === 'flex') {
            let extensionInfo = currentActiveExtension;
            if (currentEmployeeName) { extensionInfo += ` (${currentEmployeeName})`; }
            contentToShow = `<span class="loading-spinner"></span>${message} Máy nhánh: ${extensionInfo}`;
        }
        targetDiv.innerHTML = contentToShow;
        targetDiv.classList.remove('success', 'error');
        if (type === 'success') targetDiv.classList.add('success');
        else if (type === 'error') targetDiv.classList.add('error');
        targetDiv.style.opacity = '1';
        if (statusClearTimer && targetDiv === statusDiv) clearTimeout(statusClearTimer);
        if (duration) {
            const timerId = setTimeout(() => {
                if (targetDiv === statusDiv || targetDiv === hangupStatusDiv) clearStatus(targetDiv);
                else {
                    targetDiv.style.opacity = '0';
                    setTimeout(() => {
                        if (targetDiv.style.opacity === '0') {
                            targetDiv.innerHTML = '';
                            targetDiv.classList.remove('success', 'error');
                            targetDiv.style.opacity = '1';
                        }
                    }, 500);
                }
            }, duration);
            if (targetDiv === statusDiv) statusClearTimer = timerId;
        } else if (targetDiv === statusDiv) {
            statusClearTimer = null;
        }
    }
}

function clearStatus(targetDiv = statusDiv) {
    if (targetDiv) {
        targetDiv.style.opacity = '0';
        setTimeout(() => {
            if (targetDiv.style.opacity === '0') {
                targetDiv.innerHTML = '';
                targetDiv.classList.remove('success', 'error');
                targetDiv.style.opacity = '1';
                if (targetDiv === statusDiv && currentActiveExtension && mainContentContainer && mainContentContainer.style.display === 'flex' && (!webrtcCallPopup || webrtcCallPopup.style.display === 'none')) {
                    const isAppViewVisible = (window.innerWidth >= 800) || (appContainer && appContainer.style.display === 'block');
                    if (isAppViewVisible && !statusDiv.innerHTML.includes('Đang thực hiện cuộc gọi...') && !statusDiv.innerHTML.includes('Yêu cầu gọi đến')) {
                        displayStatus('Hệ thống đang trực tuyến. Sẵn sàng gọi.', 'success', 5000);
                    }
                }
            }
        }, 500);
    }
    if (targetDiv === statusDiv) statusClearTimer = null;
}

function handleInputFocus(event) {
    if (window.innerWidth < 800) {
        setTimeout(() => {
            if (event.target) event.target.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }, 300);
    }
}

async function checkIpPeriodically() {
    const isTokenEntryVisible = tokenEntryContainer ? tokenEntryContainer.style.display !== 'none' : false;
    const isIpRestrictionVisible = ipRestrictionMessageDiv ? ipRestrictionMessageDiv.style.display !== 'none' : false;
    const isMainContentVisible = mainContentContainer ? mainContentContainer.style.display === 'flex' : false;

    if (!savedActualToken && !isAttemptingAutoLogin && !isTokenEntryVisible && !isIpRestrictionVisible) {
        appendLog("Không có token hoặc đang tự đăng nhập (và không ở màn hình lỗi IP). Dừng kiểm tra IP.");
        clearInterval(ipCheckIntervalId);
        clearInterval(fastIpCheckIntervalId);
        ipCheckIntervalId = null;
        fastIpCheckIntervalId = null;
        return;
    }

    appendLog("Đang kiểm tra IP định kỳ.");
    try {
        const checkIpUrl = `${WORKER_BASE_URL}/dial`;
        const formData = new URLSearchParams({ token: savedActualToken || 'temp_token_for_ip_check', phone: 'ip_check_ping' });

        const response = await fetch(checkIpUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });

        workerConnectionFailures = 0;

        const responseData = await response.json();

        if (responseData.version) { updateVersionDisplay(responseData.version); }
        if (responseData.supportPhone && responseData.supportPersonName) { updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName); }


        if (response.status === 403) {
            const errorMessage = `Truy cập không thành công hoặc giấy phép đã hết hạn. Vui lòng liên hệ: ${formatPhoneNumber(responseData.supportPhone || currentSupportPhone)} (${responseData.supportPersonName || currentSupportPersonName}) để được hỗ trợ - Mã lỗi: 862840`;
            handleIpRestriction(errorMessage);
        } else if (!response.ok) {
            appendLog(`Worker phản hồi không thành công trong quá trình kiểm tra IP: ${response.status}, ${JSON.stringify(responseData)}`);
            if (ipRestrictionMessageDiv && ipRestrictionMessageDiv.style.display !== 'none') {
                revalidateAndLoginIfIpOk();
            } else if (!savedActualToken) {
                if(mainContentContainer) mainContentContainer.style.display = 'none';
                if(tokenEntryContainer) {
                    tokenEntryContainer.style.display = 'block';
                    tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
                }
                displayStatus('Vui lòng nhập token máy nhánh.', '', 5000, tokenStatusDiv);
            }
        } else {
            appendLog("Kiểm tra IP định kỳ thành công. IP vẫn hợp lệ.");
            stopFastIpCheck();
            revalidateAndLoginIfIpOk();
        }

    } catch (error) {
        appendLog(`Lỗi khi kiểm tra IP định kỳ (fetch error): ${error}`);
        workerConnectionFailures++;
        appendLog(`Số lần kết nối Worker thất bại: ${workerConnectionFailures}`);

        if (workerConnectionFailures >= MAX_CONNECTION_FAILURES) {
            appendLog("Mất kết nối Worker. Đang thực hiện đăng xuất cưỡng bức.");
            alert("Mất kết nối với máy chủ. Hệ thống sẽ tự động đăng xuất để bảo mật.");
            logoutUser();
        } else if (savedActualToken && !isIpRestrictionVisible && !isMainContentVisible) {
            startFastIpCheck();
        }
    }
}

function startIpCheckInterval() {
    if (ipCheckIntervalId) { clearInterval(ipCheckIntervalId); }
    clearInterval(fastIpCheckIntervalId);
    fastIpCheckIntervalId = null;
    checkIpPeriodically();
    ipCheckIntervalId = setInterval(checkIpPeriodically, 10000);
    appendLog("Đã bắt đầu kiểm tra IP định kỳ (chậm).");
}

function startFastIpCheck() {
    if (fastIpCheckIntervalId) { clearInterval(fastIpCheckIntervalId); }
    if (ipCheckIntervalId) { clearInterval(ipCheckIntervalId); ipCheckIntervalId = null; }
    fastIpCheckIntervalId = setInterval(checkIpPeriodically, 3000);
    appendLog("Đã bắt đầu kiểm tra IP định kỳ (NHANH).");
}

function stopFastIpCheck() {
    if (fastIpCheckIntervalId) { clearInterval(fastIpCheckIntervalId); fastIpCheckIntervalId = null; appendLog("Đã dừng kiểm tra IP định kỳ (NHANH)."); }
    if ((mainContentContainer && mainContentContainer.style.display === 'flex') && ipCheckIntervalId === null) {
        startIpCheckInterval();
    }
}

function handleIpRestriction(message) {
    if (voip24hModuleInstance) voip24hModuleInstance.release();
    if (ipCheckIntervalId) { clearInterval(ipCheckIntervalId); ipCheckIntervalId = null; }
    if (fastIpCheckIntervalId) { clearInterval(fastIpCheckIntervalId); fastIpCheckIntervalId = null; }
    if (peerStatusInterval) {
        clearInterval(peerStatusInterval);
        peerStatusInterval = null;
    }

    if (mainContentContainer) mainContentContainer.style.display = 'none';
    if (tokenEntryContainer) tokenEntryContainer.style.display = 'none';
    if (logContainer) logContainer.style.display = 'block';

    if (webrtcCallPopup && webrtcCallPopup.style.display === 'flex') {
        hideWebRTCCallPopup();
        appendLog("Đã ẩn popup cuộc gọi do lỗi hạn chế IP.");
    }

    if (ipRestrictionMessageDiv) {
        ipRestrictionMessageDiv.innerHTML = message;
        ipRestrictionMessageDiv.style.display = 'block';
        ipRestrictionMessageDiv.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
    }

    savedActualToken = null;
    currentActiveExtension = null;
    currentEmployeeName = null;
    currentSipPassword = null;
    isSipRegistered = false;
    if(extensionDisplay) extensionDisplay.value = "Không khả dụng";
    if(controlExtensionDisplay) controlExtensionDisplay.value = "Không khả dụng";
    if(callButton) callButton.disabled = true;
    if(hangupButton) hangupButton.disabled = true;
    if(webRtcCallButton) webRtcCallButton.disabled = true;

    displayStatus('', '', 0, tokenStatusDiv);
    clearStatus();
    clearStatus(hangupStatusDiv);

    appendLog("User logged out due to IP restriction.");
}

function logoutUser() {
    if (peerStatusInterval) {
        clearInterval(peerStatusInterval);
        peerStatusInterval = null;
    }
    appendLog("Bắt đầu quá trình đăng xuất.");
    localStorage.removeItem(SAVED_TOKEN_KEY);
    location.reload();
}

async function revalidateAndLoginIfIpOk() {
    const storedToken = localStorage.getItem(SAVED_TOKEN_KEY);
    if (storedToken && !isAttemptingAutoLogin && (!tokenEntryContainer || tokenEntryContainer.style.display !== 'none')) {
        isAttemptingAutoLogin = true;
        appendLog("IP đã hợp lệ trở lại và có token lưu. Đang thử tự động đăng nhập lại...");
        if (ipRestrictionMessageDiv) {
            ipRestrictionMessageDiv.innerHTML = '<span class="loading-spinner"></span> Đang thử đăng nhập lại tự động...';
            ipRestrictionMessageDiv.style.display = 'block';
        }
        if (tokenEntryContainer) tokenEntryContainer.style.display = 'none';

        if (tokenStatusDiv) { tokenStatusDiv.innerHTML = ''; tokenStatusDiv.classList.remove('error'); }

        const success = await validateAndSetToken(storedToken, true);
        if (success) { appendLog("Tự động đăng nhập lại thành công."); stopFastIpCheck(); } else { appendLog("Tự động đăng nhập lại thất bại. IP có thể vẫn không hợp lệ hoặc token đã hết hạn."); }
        isAttemptingAutoLogin = false;
    } else if ((mainContentContainer && mainContentContainer.style.display === 'flex') && (!ipRestrictionMessageDiv || ipRestrictionMessageDiv.style.display !== 'none')) {
        if (ipRestrictionMessageDiv) ipRestrictionMessageDiv.style.display = 'none';
        appendLog("Thông báo IP Restriction đã được ẩn do IP hợp lệ trở lại.");
    }
}

async function validateAndSetToken(tokenToValidate, isInitialLoadOrSilent = false) {
    appendLog(`validateAndSetToken called. Token: ${tokenToValidate}, Initial/Silent: ${isInitialLoadOrSilent}`);

    if (ipRestrictionMessageDiv) ipRestrictionMessageDiv.style.display = 'none';
    if (!tokenToValidate) {
        displayStatus('Vui lòng nhập token.', 'error', 3000, tokenStatusDiv);
        if(tokenEntryContainer) tokenEntryContainer.style.display = 'block';
        if(mainContentContainer) mainContentContainer.style.display = 'none';
        return false;
    }

    if (!isInitialLoadOrSilent) {
        unlockAudioContext();
    }

    displayStatus('<span class="loading-spinner"></span> Đang xác thực token...', '', null, tokenStatusDiv);
    try {
        const verifyTokenUrl = `${WORKER_BASE_URL}/dial`;
        const formData = new URLSearchParams({ token: tokenToValidate, phone: '0000000000' });
        const response = await fetch(verifyTokenUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });
        const responseData = await response.json();
        appendLog(`Worker response status (validation): ${response.status}, data: ${JSON.stringify(responseData)}`);

        if (responseData.version) { updateVersionDisplay(responseData.version); }
        if (responseData.supportPhone && responseData.supportPersonName) { updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName); }

        if (responseData.extension) { currentActiveExtension = responseData.extension; } else { currentActiveExtension = tokenToValidate; }

        if (responseData.employeeName) { currentEmployeeName = responseData.employeeName; }

        if (extensionDisplay) extensionDisplay.value = `${currentActiveExtension} (${currentEmployeeName || 'Người dùng'})`;
        if (controlExtensionDisplay) controlExtensionDisplay.value = `${currentActiveExtension} (${currentEmployeeName || 'Người dùng'})`;

        if (responseData.password) {
            try {
                const decodedPassword = atob(responseData.password);
                currentSipPassword = xorCipher(decodedPassword, SECRET_KEY);
                appendLog("Mật khẩu SIP đã được nhận và giải mã thành công.");
            } catch (e) {
                appendLog("Lỗi giải mã mật khẩu Base64. Có thể Worker chưa mã hóa.");
                currentSipPassword = responseData.password;
            }
        } else {
            currentSipPassword = null;
            appendLog("Worker không cung cấp mật khẩu SIP.");
        }

        if (response.status === 403) {
            const errorMessage = `Truy cập không thành công hoặc giấy phép đã hết hạn. Vui lòng liên hệ: ${formatPhoneNumber(responseData.supportPhone || currentSupportPhone)} (${responseData.supportPersonName || currentSupportPersonName}) để được hỗ trợ - Mã lỗi: 862840`;
            handleIpRestriction(errorMessage);
            return false;
        } else if (!response.ok) {
            displayStatus(`Lỗi xác thực: ${responseData.message || 'Token không hợp lệ hoặc lỗi không xác định'}`, 'error', 5000, tokenStatusDiv);
            if(mainContentContainer) mainContentContainer.style.display = 'none';
            if(tokenEntryContainer) {
                tokenEntryContainer.style.display = 'block';
                tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
            }
            isSipRegistered = false;
            currentActiveExtension = null;
            currentSipPassword = null;
            if(extensionDisplay) extensionDisplay.value = "Không khả dụng";
            if(controlExtensionDisplay) controlExtensionDisplay.value = "Không khả dụng";
            return false;
        }

        localStorage.setItem(SAVED_TOKEN_KEY, tokenToValidate);
        savedActualToken = tokenToValidate;

        await setupPusherListener();

        await fetchContactList();
        await fetchForwardingExtensions();

        if(tokenEntryContainer) tokenEntryContainer.style.display = 'none';
        if(mainContentContainer) {
            mainContentContainer.style.display = 'flex';
            if (window.innerWidth < 800) { showAppView(); } else {
                if(appContainer) appContainer.style.display = 'block';
                if(callControlContainer) callControlContainer.style.display = 'block';
                if(contactListContainer) contactListContainer.style.display = 'block';
            }
            if (isInitialLoadOrSilent) { mainContentContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards'; }
        }
        renderContactList();
        if(callButton) callButton.disabled = true;
        if(hangupButton) hangupButton.disabled = false;
        if(webRtcCallButton) webRtcCallButton.disabled = true;
        if (tokenInput) tokenInput.value = '';
        if (tokenStatusDiv) tokenStatusDiv.innerHTML = '';
        if (logContainer) logContainer.style.display = 'block';

        displayStatus('Hệ thống đang trực tuyến. Đang cố gắng đăng ký SIP...', 'success', 5000);
        startIpCheckInterval();
        stopFastIpCheck();

        if (currentActiveExtension && currentSipPassword) {
            registerSipAccount(currentActiveExtension, currentSipPassword);
        } else {
            appendLog("Không đủ thông tin SIP để đăng ký. Kiểm tra cấu hình Worker.");
            displayStatus('Lỗi: Không đủ thông tin SIP để đăng ký máy nhánh.', 'error', 0, statusDiv);
            isSipRegistered = false;
        }

        if (peerStatusInterval) clearInterval(peerStatusInterval);
        fetchAndRenderPeerStatus();
        peerStatusInterval = setInterval(fetchAndRenderPeerStatus, 15000);
        appendLog("Đã bắt đầu theo dõi trạng thái máy nhánh.");

        return true;
    } catch (error) {
        appendLog(`Error during token validation fetch: ${error}`);
        displayStatus(`Lỗi kết nối đến dịch vụ xác thực: ${error.message}.`, 'error', 7000, tokenStatusDiv);
        if(mainContentContainer) mainContentContainer.style.display = 'none';
        if(tokenEntryContainer) {
            tokenEntryContainer.style.display = 'block';
            tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
        }
        isSipRegistered = false;
        return false;
    }
}

function handleTokenSubmit() {
    appendLog("handleTokenSubmit called.");
    if (tokenInput) {
        const enteredToken = tokenInput.value.trim();
        if (enteredToken) {
            displayStatus('<span class="loading-spinner"></span> Đang đăng nhập và tải lại...', '', null, tokenStatusDiv);
            localStorage.setItem(SAVED_TOKEN_KEY, enteredToken);
            location.reload();
        } else {
            displayStatus('Vui lòng nhập token.', 'error', 3000, tokenStatusDiv);
        }
    } else {
        appendLog("Token input element not found.");
    }
}

async function makeCall(phoneNumberToDial = null, contactNameToDial = null) {
    isCallActive = true;
    appendLog(`makeCall (IP Phone) called. Phone: ${phoneNumberToDial}, Contact: ${contactNameToDial}`);
    if (!savedActualToken) {
        displayStatus('Lỗi: Không tìm thấy token đăng nhập. Vui lòng đăng nhập lại.', 'error', 5000);
        isCallActive = false;
        return;
    }

    let phoneNumber = phoneNumberToDial || (phoneNumberField ? phoneNumberField.value : '');
    
    if (phoneNumber && phoneNumber === currentActiveExtension) {
        displayStatus('Bạn không thể gọi điện cho chính mình.', 'error', 5000);
        isCallActive = false;
        return;
    }

    if (!phoneNumber) {
        displayStatus('Vui lòng nhập số điện thoại!', 'error', 5000);
        isCallActive = false;
        return;
    }
    if (!/^\d+$/.test(phoneNumber)) {
        displayStatus(nonNumericInputErrorMsg, 'error', 3000);
        isCallActive = false;
        return;
    }

    const callTargetDisplay = contactNameToDial || phoneNumber;
    const workerCallUrl = `${WORKER_BASE_URL}/dial`;
    const formData = new URLSearchParams({ token: savedActualToken, phone: phoneNumber });

    displayStatus(`Đang yêu cầu gọi đến <span class="phone-highlight">${callTargetDisplay}</span>...`, '', 10000);
    try {
        const response = await fetch(workerCallUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });
        const responseData = await response.json();
        appendLog(`Call worker response: ${response.status}, data: ${JSON.stringify(responseData)}`);
        if (responseData.version) { updateVersionDisplay(responseData.version); }
        if (responseData.supportPhone && responseData.supportPersonName) { updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName); }

        if (response.ok) {
            playSound(PHONE_RINGING_SOUND_URL);
            displayStatus(`Đã gửi yêu cầu gọi thành công đến <span class="phone-highlight">${callTargetDisplay}</span>! Vui lòng chờ chuông reo trên máy nhánh của bạn.`, 'success', 10000);
        } else {
            if (response.status === 403) {
                const errorMessage = `Truy cập không thành công hoặc giấy phép đã hết hạn. Vui lòng liên hệ: ${formatPhoneNumber(responseData.supportPhone || currentSupportPhone)} (${responseData.supportPersonName || currentSupportPersonName}) để được hỗ trợ - Mã lỗi: 862840`;
                handleIpRestriction(errorMessage);
            } else {
                displayStatus(`Lỗi khi gọi: ${responseData.message || 'Không thể thực hiện cuộc gọi'}`, 'error', 10000);
            }
        }
    } catch (error) {
        appendLog(`Error during call fetch: ${error}`);
        displayStatus('Lỗi kết nối đến dịch vụ gọi điện.', 'error', 10000);
    } finally {
        if (phoneNumberField) phoneNumberField.value = '';
        setTimeout(() => {
            if (!webrtcCallPopup || webrtcCallPopup.style.display === 'none') {
                displayStatus('Hệ thống đang trực tuyến. Sẵn sàng gọi.', 'success', 5000);
                isCallActive = false;
            }
        }, 10000);
    }
}

async function hangUpIPCall() {
    appendLog("hangUpIPCall called.");
    if (!savedActualToken || !currentActiveExtension) {
        displayStatus('Lỗi: Không tìm thấy token đăng nhập hoặc máy nhánh. Vui lòng đăng nhập lại.', 'error', 5000, hangupStatusDiv);
        return;
    }

    const workerHangupUrl = `${WORKER_BASE_URL}/hangup`;
    const formData = new URLSearchParams({ token: savedActualToken, extension: currentActiveExtension });
    displayStatus(`Đang yêu cầu kết thúc cuộc gọi cho máy nhánh ${currentActiveExtension}...`, '', null, hangupStatusDiv);
    if (hangupButton) hangupButton.disabled = true;

    try {
        const response = await fetch(workerHangupUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });
        const responseData = await response.json();
        appendLog(`Hangup worker response: ${response.status}, data: ${JSON.stringify(responseData)}`);
        if (responseData.version) { updateVersionDisplay(responseData.version); }
        if (responseData.supportPhone && responseData.supportPersonName) { updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName); }

        if (response.ok) {
            playSound(HANGUP_SOUND_URL);
            displayStatus(`Đã gửi yêu cầu kết thúc cuộc gọi thành công cho máy nhánh ${currentActiveExtension}.`, 'success', 5000, hangupStatusDiv);
        } else {
            if (response.status === 403) {
                const errorMessage = `Truy cập không thành công hoặc giấy phép đã hết hạn. Vui lòng liên hệ: ${formatPhoneNumber(responseData.supportPhone || currentSupportPhone)} (${responseData.supportPersonName || currentSupportPersonName}) để được hỗ trợ - Mã lỗi: 862840`;
                handleIpRestriction(errorMessage);
            } else {
                displayStatus(`Lỗi khi kết thúc cuộc gọi: ${responseData.message || 'Không thể kết thúc cuộc gọi'}`, 'error', 10000, hangupStatusDiv);
            }
        }
    } catch (error) {
        appendLog(`Error during hangup fetch: ${error}`);
        displayStatus('Lỗi kết nối đến dịch vụ kết thúc cuộc gọi.', 'error', 10000);
    } finally {
        if (hangupButton) hangupButton.disabled = false;
    }
}

async function initiateWebRTCCall() {
    let phoneNumber = phoneNumberField ? phoneNumberField.value : '';
    
    if (phoneNumber && phoneNumber === currentActiveExtension) {
        displayStatus('Bạn không thể gọi điện cho chính mình.', 'error', 5000);
        return;
    }

    if (!phoneNumber) {
        displayStatus('Vui lòng nhập số điện thoại để gọi trực tiếp trên web!', 'error', 5000);
        return;
    }
    if (!/^\d+$/.test(phoneNumber)) {
        displayStatus(nonNumericInputErrorMsg, 'error', 3000);
        return;
    }

    if (!isSipRegistered) {
        displayStatus("Bạn chưa đăng ký tài khoản SIP cho WebRTC. Vui lòng đăng ký trước khi gọi.", 'error', 5000);
        alert("Bạn chưa đăng ký tài khoản SIP cho WebRTC. Vui lòng đăng ký trước khi gọi.");
        return;
    }

    if (voip24hModuleInstance) {
        appendLog(`Đang gọi trực tiếp WebRTC đến số: ${phoneNumber}`);
        displayStatus(`Đang gọi trực tiếp qua WebRTC đến <span class="phone-highlight">${phoneNumber}</span>...`, '', 5000);
        const contact = dynamicContacts.find(c => (c.ext && c.ext.includes(phoneNumber)) || (c.mobile && c.mobile.includes(phoneNumber))) || { name: phoneNumber, phone: phoneNumber, avatar: `https://i.pravatar.cc/150?u=${phoneNumber}` };
        showWebRTCCallPopup('outgoing', contact);
        voip24hModuleInstance.call(phoneNumber);
        if (phoneNumberField) phoneNumberField.value = '';
    } else {
        appendLog("Module WebRTC chưa được khởi tạo. Không thể thực hiện cuộc gọi.");
        displayStatus("Lỗi: Module WebRTC chưa được khởi tạo. Không thể thực hiện cuộc gọi.", 'error', 5000);
    }
}

function answerWebRTCCall() {
    if (voip24hModuleInstance) {
        appendLog("Đang trả lời cuộc gọi WebRTC.");
        voip24hModuleInstance.answer();

        if (webrtcAnswerButton) webrtcAnswerButton.style.display = 'none';
        if (webrtcDeclineButton) webrtcDeclineButton.style.display = 'none';
        if (webrtcHangupButton) webrtcHangupButton.style.display = 'flex';

        if (webrtcSpeakerButton) webrtcSpeakerButton.style.display = 'flex';
        if (webrtcKeypadButton) webrtcKeypadButton.style.display = 'flex';
        if (webrtcMuteButton) webrtcMuteButton.style.display = 'flex';
        if (webrtcHoldButton) webrtcHoldButton.style.display = 'flex';
        
        const networkStatus = document.getElementById('network-status');
        if(networkStatus) networkStatus.style.display = 'flex';
        if (!networkCheckInterval) {
            networkCheckInterval = setInterval(checkGeneralNetworkQuality, 2000);
        }

        startCallTimer();
        stopSound();
        displayStatus('Đã trả lời cuộc gọi.', 'success', 3000);
    }
}

function rejectWebRTCCall() {
    if (voip24hModuleInstance) {
        appendLog("Đang từ chối cuộc gọi WebRTC.");
        voip24hModuleInstance.reject();
        hideWebRTCCallPopup();
        stopSound();
        displayStatus('Đã từ chối cuộc gọi.', 'error', 3000);
    }
}

function hangUpWebRTCCall() {
    if (voip24hModuleInstance) {
        appendLog("Đang ngắt cuộc gọi WebRTC.");
        voip24hModuleInstance.hangUp();
        hideWebRTCCallPopup();
        stopSound();
        displayStatus('Cuộc gọi đã kết thúc.', 'success', 3000);
    }
}

async function toggleWebRTCMute() {
    if (isProcessingAction || !voip24hModuleInstance) {
        appendLog("Hành động đang được xử lý. Bỏ qua yêu cầu bật/tắt mic.");
        return;
    }

    isProcessingAction = true;
    if (webrtcMuteButton) webrtcMuteButton.disabled = true;
    appendLog("Đang bật/tắt mic WebRTC...");

    try {
        await voip24hModuleInstance.toggleMute();
        const isMuted = await voip24hModuleInstance.isMute();
        if (webrtcMuteButton) {
            if (isMuted) {
                webrtcMuteButton.classList.add('active');
                if (webrtcMuteButton.querySelector('img')) webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic-off.svg';
                webrtcMuteButton.title = 'Bật tiếng';
            } else {
                webrtcMuteButton.classList.remove('active');
                if (webrtcMuteButton.querySelector('img')) webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic.svg';
                webrtcMuteButton.title = 'Tắt tiếng';
            }
        }
    } catch (error) {
        appendLog(`Lỗi khi bật/tắt mic: ${error}`);
        displayStatus('Lỗi khi thực hiện tắt tiếng.', 'error', 3000);
    } finally {
        isProcessingAction = false;
        if (webrtcMuteButton) webrtcMuteButton.disabled = false;
    }
}

async function toggleWebRTCHold() {
    if (isProcessingAction || !voip24hModuleInstance) {
        appendLog("Hành động đang được xử lý. Bỏ qua yêu cầu giữ/bỏ giữ.");
        return;
    }

    isProcessingAction = true;
    if (webrtcHoldButton) webrtcHoldButton.disabled = true;
    appendLog("Đang giữ/bỏ giữ cuộc gọi WebRTC...");

    try {
        await voip24hModuleInstance.toggleHold();
        const isHeld = await voip24hModuleInstance.isHold();
        if (webrtcHoldButton) {
            if (isHeld) {
                webrtcHoldButton.classList.add('active');
                if (webrtcHoldButton.querySelector('img')) webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:play-arrow.svg';
                webrtcHoldButton.title = 'Tiếp tục cuộc gọi';
            } else {
                webrtcHoldButton.classList.remove('active');
                if (webrtcHoldButton.querySelector('img')) webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:pause.svg';
                webrtcHoldButton.title = 'Giữ cuộc gọi';
            }
        }
    } catch (error) {
        appendLog(`Lỗi khi giữ/bỏ giữ cuộc gọi: ${error}`);
        displayStatus('Lỗi khi thực hiện giữ cuộc gọi.', 'error', 3000);
    } finally {
        isProcessingAction = false;
        if (webrtcHoldButton) webrtcHoldButton.disabled = false;
    }
}


function renderTransferModalList(withAnimation = true) {
    const extensionList = document.getElementById('transfer-extension-list');
    const timestampDiv = document.getElementById('transfer-timestamp');

    if (!extensionList || !timestampDiv) return;

    extensionList.innerHTML = ''; 

    const useDynamicList = latestPeerStatusData && latestPeerStatusData.length > 0;
    const dataToRender = useDynamicList ? latestPeerStatusData : forwardingExtensions;
    
    if (useDynamicList && lastPeerStatusTimestamp) {
        const formattedTime = lastPeerStatusTimestamp.toLocaleString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
        timestampDiv.textContent = `Cập nhật lần cuối: ${formattedTime}`;
    } else {
        timestampDiv.textContent = 'Danh sách chuyển tiếp tĩnh';
    }

    if (dataToRender.length === 0) {
        extensionList.innerHTML = '<li style="cursor: default; padding: 12px;">Không có máy nhánh nào để chuyển tiếp.</li>';
        return;
    }

    dataToRender.forEach((extData, index) => {
        const listItem = document.createElement('li');
        listItem.className = 'transfer-list-item';
        if (withAnimation) {
             listItem.classList.add('animate-in');
             listItem.style.animationDelay = `${index * 0.05}s`;
        }

        const extensionToTransfer = useDynamicList ? extData.extension : extData.ext;
        const employeeName = extData.name;
        const statusMessage = extData.statusData?.data?.messageExt;
        const isOnline = statusMessage === 'online';
        const isBusy = !!activeCallStates[extensionToTransfer];
        
        const statusClass = isOnline ? 'online' : 'offline';
        const statusTitle = isOnline ? 'Online' : `Offline (${statusMessage || 'N/A'})`;
        
        listItem.innerHTML = `<span class="status-dot ${statusClass}" title="${statusTitle}"></span><span>${employeeName} (${extensionToTransfer})</span>`;

        if (isOnline && !isBusy) {
            listItem.addEventListener('click', () => {
                if (extensionToTransfer === currentActiveExtension) {
                    alert('Lỗi: Bạn không thể chuyển tiếp cuộc gọi cho chính mình!');
                    return;
                }
                const modal = document.getElementById('transfer-modal');
                if (modal) {
                    modal.classList.remove('show');
                    modal.classList.add('hide');
                    setTimeout(() => {
                        modal.style.display = 'none';
                        modal.classList.remove('hide');
                    }, 150);
                }
                if (voip24hModuleInstance) {
                    appendLog(`Đang chuyển cuộc gọi đến: ${extensionToTransfer}`);
                    voip24hModuleInstance.transfer(extensionToTransfer);
                    displayStatus(`Đã yêu cầu chuyển cuộc gọi đến máy nhánh ${extensionToTransfer}.`, 'success', 4000);
                }
            });
        } else {
            listItem.classList.add(isBusy ? 'busy' : 'disabled');
            listItem.title = isBusy ? 'Không thể chuyển tiếp: Máy nhánh đang bận' : 'Không thể chuyển tiếp: Máy nhánh đang offline';
        }
        extensionList.appendChild(listItem);
    });
}


function transferCall() {
    if (webrtcKeypadButton && webrtcKeypadButton.disabled === true) {
        appendLog("Nút chuyển tiếp đang bị vô hiệu hoá, không thể thực hiện.");
        return;
    }
    
    if (!isCallActive) {
        alert("Không có cuộc gọi nào đang hoạt động để chuyển tiếp.");
        return;
    }
    const modal = document.getElementById('transfer-modal');
    if (!modal) return;
    
    isFirstTransferModalRender = true;
    renderTransferModalList(isFirstTransferModalRender);
    isFirstTransferModalRender = false; 
    
    modal.style.display = 'flex';
    modal.classList.add('show');
}


function sendDtmfSignal() {
    const dtmfNumber = prompt("Nhập tín hiệu DTMF (số hoặc #*):");
    if (voip24hModuleInstance && dtmfNumber) {
        appendLog(`Đang gửi DTMF: ${dtmfNumber}`);
        voip24hModuleInstance.sendDtmf(dtmfNumber);
    } else if (!dtmfNumber) {
        appendLog("Không có tín hiệu DTMF để gửi.");
    }
}

function releaseProcess() {
    if (voip24hModuleInstance) {
        appendLog("Đang hủy tiến trình WebRTC.");
        voip24hModuleInstance.release();
    }
}

function setupAutoRefresh() {
    const PAGE_RELOAD_TIME = 300 * 60 * 1000;
    appendLog(`Thiết lập tự động tải lại trang sau ${PAGE_RELOAD_TIME / 1000 / 60} phút.`);
    setTimeout(() => {
        appendLog("Đang tải lại trang tự động...");
        location.reload();
    }, PAGE_RELOAD_TIME);
}

function setupSecurityFeatures() {
    document.addEventListener('contextmenu', event => event.preventDefault());
    document.addEventListener('keydown', function(e) {
        if (e.keyCode === 123 || (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) || (e.ctrlKey && e.keyCode === 85) || (e.ctrlKey && e.keyCode === 83)) {
            e.preventDefault();
        }
    });
}

async function checkGeneralNetworkQuality() {
    try {
        const startTime = Date.now();
        const testUrl = 'https://www.google.com/images/cleardot.gif?t=' + startTime;
        await fetch(testUrl, { cache: 'no-store', mode: 'no-cors' });
        const latency = Date.now() - startTime;

        const networkStatusDiv = document.getElementById('network-status');
        if (!networkStatusDiv) return;

        networkStatusDiv.classList.remove('good', 'average', 'poor');
        let quality = '';
        let title = '';

        if (latency > 300) {
            quality = 'poor';
            title = 'Chất lượng mạng kém';
        } else if (latency > 150) {
            quality = 'average';
            title = 'Chất lượng mạng trung bình';
        } else {
            quality = 'good';
            title = 'Chất lượng mạng tốt';
        }

        networkStatusDiv.classList.add(quality);
        networkStatusDiv.title = `${title} (Độ trễ: ${latency}ms)`;

    } catch (error) {
        console.error("Lỗi khi đo chất lượng mạng: ", error);
        appendLog(`Lỗi khi đo chất lượng mạng: ${error}`);
        const networkStatusDiv = document.getElementById('network-status');
        if (networkStatusDiv) {
            networkStatusDiv.classList.remove('good', 'average');
            networkStatusDiv.classList.add('poor');
            networkStatusDiv.title = 'Mất kết nối';
        }
    }
}


function setupEventListeners() {
    if (callButton) callButton.addEventListener('click', makeCall);
    if (hangupButton) hangupButton.addEventListener('click', hangUpIPCall);
    if (webRtcCallButton) webRtcCallButton.addEventListener('click', initiateWebRTCCall);
    if (webrtcAnswerButton) webrtcAnswerButton.addEventListener('click', answerWebRTCCall);
    if (webrtcDeclineButton) webrtcDeclineButton.addEventListener('click', rejectWebRTCCall);
    if (webrtcHangupButton) webrtcHangupButton.addEventListener('click', hangUpWebRTCCall);
    if (webrtcMuteButton) webrtcMuteButton.addEventListener('click', toggleWebRTCMute);
    if (webrtcHoldButton) webrtcHoldButton.addEventListener('click', toggleWebRTCHold);
    if (webrtcKeypadButton) webrtcKeypadButton.addEventListener('click', transferCall);
    if (document.getElementById('open-contacts-btn')) document.getElementById('open-contacts-btn').addEventListener('click', showContactsView);
    if (document.getElementById('close-contacts-view-btn')) document.getElementById('close-contacts-view-btn').addEventListener('click', showAppView);
    if (document.getElementById('open-call-control-btn')) document.getElementById('open-call-control-btn').addEventListener('click', showCallControlView);
    if (document.getElementById('close-call-control-btn')) document.getElementById('close-call-control-btn').addEventListener('click', showAppView);
    if (tokenSubmitButton) tokenSubmitButton.addEventListener('click', handleTokenSubmit);
    if (openZaloBtn) openZaloBtn.addEventListener('click', showZaloView);
    if (closeZaloBtn) closeZaloBtn.addEventListener('click', showAppView);
    if (zaloModalConfirmBtn) zaloModalConfirmBtn.addEventListener('click', hideZaloNotificationModal);


    if (appLogo) {
        appLogo.addEventListener('click', async () => {
            const newTokenPrompt = prompt("Nhập token mới hoặc để trống để đăng xuất:");
            if (newTokenPrompt !== null) {
                const newToken = newTokenPrompt.trim();
                if (newToken === "") {
                    logoutUser();
                } else {
                    localStorage.setItem(SAVED_TOKEN_KEY, newToken);
                    location.reload();
                }
            }
        });
    }

    if (tokenInput) { tokenInput.addEventListener('focus', handleInputFocus); }
    if (phoneNumberField) {
        phoneNumberField.addEventListener('focus', handleInputFocus);
        phoneNumberField.addEventListener('input', function(event) {
            const maxLen = 11;
            const input = event.target;
            let value = input.value;
            const numericValue = value.replace(/[^0-9]/g, '');

            if (value !== numericValue) {
                displayStatus(nonNumericInputErrorMsg, 'error', 3000);
                value = numericValue;
            }
            if (value.length > maxLen) {
                displayStatus(`Số điện thoại không được vượt quá ${maxLen} số.`, 'error', 3000);
                value = value.slice(0, maxLen);
            }
            if (input.value !== value) {
                input.value = value;
            }
        });
    }

    if (voip24hModuleInstance) {
        voip24hModuleInstance.pushEventToSide({
            onmessageOutSide: function (event, data) {
                appendLog(`Event: ${event}`);

                const isCallTerminationEvent = [EventSipGateway.Hangup, EventSipGateway.CustomerHangup, EventSipGateway.EmployerHangup, EventSipGateway.Reject, 'missed', EventSipGateway.Failed, EventSipGateway.Canceled, EventSipGateway.Error].includes(event);
                const isFatalErrorEvent = [EventSipGateway.ServerDown, EventSipGateway.Destroyed, EventSipGateway.Closing, EventSipGateway.RegistrationFailed].includes(event);

                if (isCallTerminationEvent) {
                    appendLog(`Cuộc gọi kết thúc bình thường: ${event}`);
                    hideWebRTCCallPopup();
                    stopSound();
                    if (event === EventSipGateway.Hangup || event === EventSipGateway.CustomerHangup || event === EventSipGateway.EmployerHangup) { displayStatus('Cuộc gọi đã kết thúc.', 'success', 3000); } else if (event === EventSipGateway.Reject) { displayStatus('Cuộc gọi đã bị từ chối.', 'error', 3000); } else if (event === 'missed') { displayStatus('Cuộc gọi nhỡ.', 'error', 4000); } else if (event === EventSipGateway.Error) { displayStatus(`Lỗi cuộc gọi WebRTC: ${data.error}`, 'error', 5000); }
                    return;
                }

                if (isFatalErrorEvent) {
                    appendLog(`Lỗi kết nối nghiêm trọng: ${event}`);
                    hideWebRTCCallPopup();
                    stopSound();
                    displayStatus(`Mất kết nối SIP: ${event}. Đang thử kết nối lại...`, 'error', 5000);
                    isSipRegistered = false;
                    if(callButton) callButton.disabled = true;
                    if(webRtcCallButton) webRtcCallButton.disabled = true;
                    appendLog("Đang thử đăng ký lại SIP sau 5 giây do lỗi/gián đoạn.");
                    setTimeout(() => { if (currentActiveExtension && currentSipPassword) { registerSipAccount(currentActiveExtension, currentSipPassword); } }, 5000);
                    return;
                }

                if (event === EventSipGateway.Incomingcall) {
                    appendLog(`Cuộc gọi đến từ: ${data.phonenumber}`);
                    const contact = dynamicContacts.find(c => (c.ext && c.ext.includes(data.phonenumber)) || (c.mobile && c.mobile.includes(data.phonenumber))) || { name: 'Unknown Caller', phone: data.phonenumber, avatar: `https://i.pravatar.cc/150?u=${data.phonenumber}` };
                    showWebRTCCallPopup('incoming', contact);
                } else if (event === EventSipGateway.Registered) {
                    appendLog("Đăng ký tài khoản SIP thành công.");
                    isSipRegistered = true;
                    const displayName = currentEmployeeName || 'Người dùng';
                    if (extensionDisplay) extensionDisplay.value = `${currentActiveExtension} (${displayName})`;
                    if (controlExtensionDisplay) controlExtensionDisplay.value = `${currentActiveExtension} (${displayName})`;
                    if(callButton) callButton.disabled = false;
                    if(webRtcCallButton) webRtcCallButton.disabled = false;
                    displayStatus('Hệ thống đang trực tuyến. Sẵn sàng gọi.', 'success', 5000);
                } else if (event === EventSipGateway.Accepted) {
                    appendLog("Cuộc gọi đã được chấp nhận.");
                    
                    if (webrtcKeypadButton) {
                        webrtcKeypadButton.disabled = false;
                        webrtcKeypadButton.style.opacity = '1';
                        webrtcKeypadButton.style.cursor = 'pointer';
                        webrtcKeypadButton.title = 'Chuyển tiếp cuộc gọi';
                    }

                    if (callPopupStatus) {
                        callPopupStatus.textContent = 'Đang nghe';
                        callPopupStatus.className = 'call-status answered';
                    }

                    if (!networkCheckInterval) {
                        networkCheckInterval = setInterval(checkGeneralNetworkQuality, 2000);
                    }
                    if (webrtcCallPopup && webrtcCallPopup.style.display !== 'flex') {
                        showWebRTCCallPopup('active', { phone: callPopupNumber.textContent, name: callPopupName.textContent }, 'Incoming');
                    }
                    if (webrtcAnswerButton) webrtcAnswerButton.style.display = 'none';
                    if (webrtcDeclineButton) webrtcDeclineButton.style.display = 'none';
                    if (webrtcHangupButton) webrtcHangupButton.style.display = 'flex';
                    startCallTimer();
                    stopSound();
                } else if (event === EventSipGateway.Holding) {
                    appendLog("Trạng thái cuộc gọi: Đang giữ.");
                    if (webrtcHoldButton) {
                        webrtcHoldButton.classList.add('active');
                        if (webrtcHoldButton.querySelector('img')) webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:play-arrow.svg';
                        webrtcHoldButton.title = 'Tiếp tục cuộc gọi';
                    }
                } else if (event === EventSipGateway.Unholding) {
                    appendLog("Trạng thái cuộc gọi: Đã bỏ giữ.");
                    if (webrtcHoldButton) {
                        webrtcHoldButton.classList.remove('active');
                        if (webrtcHoldButton.querySelector('img')) webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:pause.svg';
                        webrtcHoldButton.title = 'Giữ cuộc gọi';
                    }
                } else if (event === EventSipGateway.Mute) {
                    appendLog("Mic đã tắt.");
                    if (webrtcMuteButton) {
                        webrtcMuteButton.classList.add('active');
                        if (webrtcMuteButton.querySelector('img')) webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic-off.svg';
                        webrtcMuteButton.title = 'Bật tiếng';
                    }
                } else if (event === EventSipGateway.Unmute) {
                    appendLog("Mic đã bật.");
                    if (webrtcMuteButton) {
                        webrtcMuteButton.classList.remove('active');
                        if (webrtcMuteButton.querySelector('img')) webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic.svg';
                        webrtcMuteButton.title = 'Tắt tiếng';
                    }
                } else if (event === EventSipGateway.Calling) {
                    appendLog("Đang gọi đi...");
                } else if (event === EventSipGateway.Transfer) {
                    appendLog("Cuộc gọi đang được chuyển tiếp.");
                }
            }
        });
    }
}

async function registerSipAccount(numberSIP = null, password = null) {
    const obfuscatedServerIp = 'MjAzLjE2Mi43OS4yMzA=';
    const ipAddressSIP = atob(obfuscatedServerIp);

    const finalNumberSIP = numberSIP || currentActiveExtension;
    const finalPassword = password || currentSipPassword;

    if (!finalNumberSIP || !finalPassword) {
        appendLog("Không thể đăng ký SIP: Thiếu số máy nhánh hoặc mật khẩu.");
        displayStatus('Lỗi: Không đủ thông tin SIP để đăng ký.', 'error', 0, statusDiv);
        isSipRegistered = false;
        return;
    }

    if (voip24hModuleInstance) {
        appendLog(`Đang đăng ký SIP với số: ${finalNumberSIP} tại ${ipAddressSIP}`);
        voip24hModuleInstance.registerSip(ipAddressSIP, finalNumberSIP, finalPassword);
    } else {
        appendLog("Module WebRTC chưa được khởi tạo. Không thể đăng ký SIP.");
        displayStatus('Lỗi: Module WebRTC chưa được khởi tạo.', 'error', 0, statusDiv);
        isSipRegistered = false;
    }
}

function setupTransferModal() {
    if (document.getElementById('transfer-modal')) return;

    const modalHTML = `
    <div id="transfer-modal" class="transfer-modal">
        <div class="transfer-modal-content">
            <div class="transfer-modal-header">
                <h2>Chọn máy nhánh để chuyển tiếp</h2>
                <span id="close-transfer-modal-btn" class="transfer-close-btn">&times;</span>
            </div>
            <ul id="transfer-extension-list"></ul>
            <div class="transfer-modal-footer">
                <div id="transfer-timestamp" class="transfer-timestamp"></div>
                <button id="confirm-close-transfer-btn" class="blue-btn">Đóng</button>
            </div>
        </div>
    </div>`;
    const styleHTML = `
        @keyframes modal-fade-in { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes modal-fade-out { from { opacity: 1; transform: translateY(0); } to { opacity: 0; transform: translateY(-20px); } }
        .transfer-modal { display: none; position: fixed; z-index: 2000; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.6); justify-content: center; align-items: center; }
        .transfer-modal.show .transfer-modal-content { animation: modal-fade-in 0.3s ease-out; }
        .transfer-modal.hide .transfer-modal-content { animation: modal-fade-out 0.15s ease-out forwards; }
        .transfer-modal-content { background-color: #fff; margin: auto; padding: 20px; border-radius: 8px; width: 90%; max-width: 400px; box-shadow: 0 5px 15px rgba(0,0,0,0.3); color: #333; }
        .transfer-modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #dee2e6; padding-bottom: 1rem; }
        .transfer-modal-header h2 { margin: 0; font-size: 1.2rem; }
        .transfer-close-btn { color: #aaa; font-size: 28px; font-weight: bold; cursor: pointer; }
        #transfer-extension-list { list-style: none; padding: 0; margin-top: 1rem; max-height: 300px; overflow-y: auto; }
        .transfer-list-item { display: flex; align-items: center; padding: 12px; border-bottom: 1px solid #eee; cursor: pointer; transition: background-color 0.2s; }
        .transfer-list-item:hover { background-color: #f1f1f1; }
        .transfer-list-item.disabled { color: #aaa; background-color: #f8f9fa; cursor: not-allowed; }
        .transfer-list-item.disabled:hover { background-color: #f8f9fa; }
        .transfer-modal-footer { display: flex; justify-content: space-between; align-items: center; padding-top: 1.5rem; border-top: 1px solid #dee2e6; margin-top: 1rem; }
        .transfer-timestamp { font-size: 0.8em; color: #6c757d; flex-grow: 1; }
        .blue-btn { background-color: #007bff; color: white; border: none; padding: 10px 20px; border-radius: 5px; font-size: 15px; cursor: pointer; transition: background-color 0.2s; }
        .blue-btn:hover { background-color: #0056b3; }
        .transfer-list-item .status-dot { width: 10px; height: 10px; border-radius: 50%; margin-right: 10px; flex-shrink: 0; }
        .transfer-list-item .status-dot.online { background-color: #28a745; }
        .transfer-list-item .status-dot.offline { background-color: #dc3545; }
        .transfer-list-item .status-dot.unknown { background-color: #6c757d; }
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    const styleContainer = document.createElement('style');
    styleContainer.innerHTML = styleHTML;
    document.head.appendChild(styleContainer);

    const modal = document.getElementById('transfer-modal');
    const closeBtn = document.getElementById('close-transfer-modal-btn');
    const confirmCloseBtn = document.getElementById('confirm-close-transfer-btn');

    if(modal && closeBtn && confirmCloseBtn) {
        const closeModal = () => {
            modal.classList.remove('show');
            modal.classList.add('hide');
            setTimeout(() => {
                modal.style.display = 'none';
                modal.classList.remove('hide');
            }, 150);
        };
        closeBtn.onclick = closeModal;
        confirmCloseBtn.onclick = closeModal;
        modal.addEventListener('click', (event) => {
            if (event.target === modal) closeModal();
        });
    }
}


function handlePusherEvent(payload) {
    if (!payload || !payload.callid) return;

    const callId = payload.callid;
    const callerExt = (payload.type === 'inbound') ? payload.phone : payload.extend;
    const calleeExt = (payload.type === 'inbound') ? payload.extend : payload.phone;
    
    appendLog(`[Pusher] Event: ${payload.state}/${payload.type} | Caller: ${callerExt}, Callee: ${calleeExt}`);

    if (payload.type === 'ended' || payload.state === 'Hangup') {
        appendLog(`[Pusher] Call ${callId} ended. Clearing states for ${callerExt} and ${calleeExt}.`);
        if (callerExt && activeCallStates[callerExt]?.callId === callId) delete activeCallStates[callerExt];
        if (calleeExt && activeCallStates[calleeExt]?.callId === callId) delete activeCallStates[calleeExt];
    } 
    else if (payload.state === 'Up') {
        appendLog(`[Pusher] Call ${callId} answered between ${callerExt} and ${calleeExt}.`);
        if (callerExt) activeCallStates[callerExt] = { status: 'in-call', peer: calleeExt, callId: callId };
        if (calleeExt) activeCallStates[calleeExt] = { status: 'in-call', peer: callerExt, callId: callId };
    }
    else if (payload.state === 'Ring') {
        appendLog(`[Pusher] Call ${callId} is ringing.`);
        if (callerExt) activeCallStates[callerExt] = { status: 'calling-out', peer: calleeExt, callId: callId };
        if (calleeExt) activeCallStates[calleeExt] = { status: 'ringing', peer: callerExt, callId: callId };
    }

    renderPeerStatus(latestPeerStatusData);
}

// === HÀM THIẾT LẬP PUSHER ĐÃ ĐƯỢC GỘP LẠI (THÊM DEBUG LOG) ===
async function setupPusherListener() {
    appendLog("Pusher Setup: Bắt đầu hàm setupPusherListener.");
    if (!savedActualToken) {
        appendLog("Pusher Setup: Lỗi - Chưa đăng nhập, không thể lấy cấu hình Pusher.");
        return;
    }

    try {
        appendLog("Pusher Setup: Đang gửi yêu cầu lấy TẤT CẢ cấu hình Pusher từ wk-test...");
        const response = await fetch(`${WORKER_BASE_URL}/get-pusher-config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ token: savedActualToken })
        });

        appendLog(`Pusher Setup: Phản hồi từ wk-test có status: ${response.status}`);
        if (!response.ok) {
            const errorData = await response.text();
            throw new Error(`Server trả về lỗi: ${response.status} - ${errorData}`);
        }

        const configs = await response.json();
        appendLog("Pusher Setup: Đã nhận và parse JSON cấu hình thành công.");
        appendLog(`Pusher Setup: Dữ liệu cấu hình nhận được: ${JSON.stringify(configs)}`);
        
        Pusher.logToConsole = false; 

        // --- 1. Thiết lập Pusher cho CUỘC GỌI (event-listener) ---
        if (configs.eventListener && configs.eventListener.key) {
            appendLog("Pusher Setup (event-listener): Tìm thấy cấu hình. Đang khởi tạo...");
            const pusherA = new Pusher(configs.eventListener.key, {
                cluster: configs.eventListener.cluster
            });
            const channelA = pusherA.subscribe('webhook-channel');
            channelA.bind('new-webhook-event', function(data) {
                appendLog('[Pusher event-listener] Nhận sự kiện mới!');
                try {
                    let webhookPayload = typeof data === 'string' ? JSON.parse(data) : data;
                    if (webhookPayload.data && typeof webhookPayload.data === 'string') {
                        webhookPayload = JSON.parse(webhookPayload.data);
                    }
                    handlePusherEvent(webhookPayload);
                } catch (e) {
                    console.error('[Pusher event-listener] Lỗi xử lý dữ liệu:', e, 'Dữ liệu gốc:', data);
                }
            });
            pusherA.connection.bind('connected', () => appendLog('Pusher Setup (event-listener): Kết nối thành công.'));
            pusherA.connection.bind('error', (err) => appendLog(`Pusher Setup (event-listener): Lỗi kết nối - ${err.error?.data?.message || 'Không rõ'}`));
        } else {
            appendLog("Pusher Setup: CẢNH BÁO - Không tìm thấy cấu hình cho event-listener.");
        }

        // --- 2. Thiết lập Pusher cho TIN NHẮN ZALO (event-zalo) ---
        if (configs.zaloListener && configs.zaloListener.key) {
            appendLog("Pusher Setup (event-zalo): Tìm thấy cấu hình. Đang khởi tạo...");
            const pusherB = new Pusher(configs.zaloListener.key, {
                cluster: configs.zaloListener.cluster
            });
            const channelB = pusherB.subscribe('zalo-oa-notifications');
            channelB.bind('new-message', function(data) {
                appendLog('[Pusher event-zalo] Nhận tin nhắn Zalo mới!');
                handleZaloMessage(data);
            });
            pusherB.connection.bind('connected', () => appendLog('Pusher Setup (event-zalo): Kết nối thành công.'));
            pusherB.connection.bind('error', (err) => appendLog(`Pusher Setup (event-zalo): Lỗi kết nối - ${err.error?.data?.message || 'Không rõ'}`));
        } else {
            appendLog("Pusher Setup: CẢNH BÁO - Không tìm thấy cấu hình cho zalo-listener.");
        }

    } catch(e) {
        console.error('Lỗi nghiêm trọng khi khởi tạo Pusher:', e);
        appendLog(`Pusher Setup: Lỗi nghiêm trọng - ${e.message}`);
    }
}

// === CÁC HÀM MỚI CHO TÍNH NĂNG ZALO ===
function playZaloAlert() {
    if (isZaloAlertPlaying) return;
    if (isCallActive) {
        appendLog("Không phát âm thanh Zalo vì đang có cuộc gọi.");
        wasZaloAlertPausedForCall = true;
        return;
    }
    zaloAlertAudio = new Audio(ZALO_ALERT_SOUND_URL);
    zaloAlertAudio.loop = true;
    zaloAlertAudio.play().catch(e => {
        console.error("Lỗi không thể phát âm thanh cảnh báo Zalo:", e);
    });
    isZaloAlertPlaying = true;
    appendLog("Đã phát âm thanh cảnh báo Zalo.");
}

function stopZaloAlert() {
    if (zaloAlertAudio) {
        zaloAlertAudio.pause();
        zaloAlertAudio.currentTime = 0;
        zaloAlertAudio = null;
    }
    isZaloAlertPlaying = false;
    appendLog("Đã dừng âm thanh cảnh báo Zalo.");
}

function showZaloNotificationModal() {
    if (zaloNotificationModal) {
        zaloNotificationModal.style.display = 'flex';
    }
}

function hideZaloNotificationModal() {
    if (zaloNotificationModal) {
        zaloNotificationModal.style.display = 'none';
    }
    // Chỉ tắt âm thanh nếu không còn tin nhắn nào chưa đọc
    const hasUnread = zaloMessageList && zaloMessageList.querySelector('.zalo-message-item.unread');
    if (!hasUnread) {
        stopZaloAlert();
    }
}

function copyToClipboard(text, element) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand('copy');
        if(element) {
            const originalText = element.textContent;
            element.textContent = 'Đã chép ID!';
            element.style.color = '#28a745';
            setTimeout(() => {
                element.textContent = originalText;
                element.style.color = '';
            }, 1500);
        }
    } catch (err) {
        console.error('Không thể sao chép:', err);
    }
    document.body.removeChild(textarea);
}


function handleZaloMessage(data) {
    if (!zaloMessageList) return;

    const emptyMessage = zaloMessageList.querySelector('.empty-list-message');
    if (emptyMessage) {
        emptyMessage.remove();
    }

    const { content, rawZaloEvent } = data;
    const senderId = rawZaloEvent.sender?.id || 'Không rõ';
    const timestamp = parseInt(rawZaloEvent.timestamp, 10);
    const messageDate = new Date(timestamp);
    const formattedTime = messageDate.toLocaleString('vi-VN', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' });

    let messageContentHTML = '';

    switch (content.type) {
        case 'text':
            messageContentHTML = `<p>${content.text}</p>`;
            break;
        case 'image':
            messageContentHTML = `<a href="${content.url}" target="_blank" rel="noopener noreferrer"><img src="${content.thumbnail}" alt="Ảnh từ Zalo"></a>`;
            break;
        case 'sticker':
            messageContentHTML = `<img src="${content.url}" alt="Sticker từ Zalo" style="width: 100px; height: 100px;">`;
            break;
        case 'audio':
            messageContentHTML = `<audio controls src="${content.url}"></audio>`;
            break;
        case 'video':
            messageContentHTML = `<video controls src="${content.url}" poster="${content.thumbnail}"></video>`;
            break;
        case 'file':
            messageContentHTML = `Đã gửi một tệp: <a href="${content.url}" target="_blank" rel="noopener noreferrer">${content.name}</a>`;
            break;
        case 'link':
            messageContentHTML = `Đã gửi một liên kết: <a href="${content.url}" target="_blank" rel="noopener noreferrer">${content.description || content.url}</a>`;
            break;
        case 'location':
            messageContentHTML = `Đã gửi một vị trí: <a href="https://www.google.com/maps?q=${content.latitude},${content.longitude}" target="_blank" rel="noopener noreferrer">Xem trên bản đồ</a>`;
            break;
        default:
            messageContentHTML = `<p><i>Loại tin nhắn không được hỗ trợ để hiển thị.</i></p>`;
    }

    const messageId = `zalo-msg-${rawZaloEvent.message?.msg_id || timestamp}`;
    const messageItem = document.createElement('div');
    messageItem.className = 'zalo-message-item unread';
    messageItem.id = messageId;
    messageItem.innerHTML = `
        <div class="zalo-message-header">
            <span class="zalo-sender-info" title="Nhấn để sao chép ID">Từ: ${senderId}</span>
            <span class="zalo-timestamp">${formattedTime}</span>
        </div>
        <div class="zalo-message-content">
            ${messageContentHTML}
        </div>
        <button class="zalo-confirm-btn">\u2705 Đã đọc</button>
    `;

    zaloMessageList.prepend(messageItem);

    const confirmButton = messageItem.querySelector('.zalo-confirm-btn');
    confirmButton.addEventListener('click', () => {
        messageItem.classList.remove('unread');
        confirmButton.textContent = '\u2714 Đã xem';
        confirmButton.disabled = true;

        const hasUnread = zaloMessageList.querySelector('.zalo-message-item.unread');
        if (!hasUnread) {
             stopZaloAlert();
             hideZaloNotificationModal();
        }
    });

    const senderInfoSpan = messageItem.querySelector('.zalo-sender-info');
    senderInfoSpan.addEventListener('click', (e) => {
        e.stopPropagation();
        copyToClipboard(senderId, senderInfoSpan);
    });

    playZaloAlert();
    showZaloNotificationModal();
}


// === ĐIỂM BẮT ĐẦU CHÍNH CỦA ỨNG DỤNG (ENTRY POINT) ===
document.addEventListener('DOMContentLoaded', async () => {
    // Gán tất cả các biến DOM
    logContainer = document.getElementById('log_container');
    logOutput = document.getElementById('log_output');
    peerStatusList = document.getElementById('peer-status-list');
    peerStatusTimestamp = document.getElementById('peer-status-timestamp');
    phoneNumberField = document.getElementById('phoneNumber');
    statusDiv = document.getElementById('status');
    tokenStatusDiv = document.getElementById('tokenStatus');
    hangupStatusDiv = document.getElementById('hangupStatus');
    mainContentContainer = document.getElementById('main-content');
    tokenEntryContainer = document.getElementById('token-entry-container');
    ipRestrictionMessageDiv = document.getElementById('ip-restriction-message');
    callButton = document.getElementById('callButton');
    hangupButton = document.getElementById('hangupButton');
    extensionDisplay = document.getElementById('extensionDisplay');
    controlExtensionDisplay = document.getElementById('controlExtensionDisplay');
    tokenInput = document.getElementById('tokenInput');
    appLogo = document.getElementById('appLogo');
    appContainer = document.getElementById('app-container');
    callControlContainer = document.getElementById('call-control-container');
    contactListContainer = document.getElementById('contact-list-container');
    tokenEntryVersionSpan = document.getElementById('tokenEntryVersion');
    callControlVersionSpan = document.getElementById('callControlVersion');
    appVersionSpan = document.getElementById('appVersion');
    contactsVersionSpan = document.getElementById('contactsVersion');
    peerStatusVersionSpan = document.getElementById('peerStatusVersion');
    tokenEntrySupportPhoneSpan = document.getElementById('tokenEntrySupportPhone');
    tokenEntrySupportNameSpan = document.getElementById('tokenEntrySupportName');
    callControlSupportPhoneSpan = document.getElementById('callControlSupportPhone');
    callControlSupportNameSpan = document.getElementById('callControlSupportName');
    appSupportPhoneSpan = document.getElementById('appSupportPhone');
    appSupportNameSpan = document.getElementById('appSupportName');
    contactsSupportPhoneSpan = document.getElementById('contactsSupportPhone');
    contactsSupportNameSpan = document.getElementById('contactsSupportName');
    peerStatusSupportPhoneSpan = document.getElementById('peerStatusSupportPhone');
    peerStatusSupportNameSpan = document.getElementById('peerStatusSupportName');
    webrtcCallPopup = document.getElementById('webrtc-call-popup');
    callPopupTime = document.getElementById('call-popup-time');
    callPopupAvatar = document.getElementById('call-popup-avatar');
    callPopupName = document.getElementById('call-popup-name');
    callPopupNumber = document.getElementById('call-popup-number');
    callPopupTimer = document.getElementById('call-popup-timer');
    callPopupStatus = document.getElementById('call-popup-status');
    webrtcSpeakerButton = document.getElementById('webrtc-speaker-button');
    webrtcKeypadButton = document.getElementById('webrtc-keypad-button');
    webrtcMuteButton = document.getElementById('webrtc-mute-button');
    webrtcHoldButton = document.getElementById('webrtc-hold-button');
    webrtcAnswerButton = document.getElementById('webrtc-answer-button');
    webrtcDeclineButton = document.getElementById('webrtc-decline-button');
    webrtcHangupButton = document.getElementById('webrtc-hangup-button');
    webRtcCallButton = document.getElementById('webRtcCallButton');
    tokenSubmitButton = document.getElementById('tokenSubmitButton');
    zaloMessagesContainer = document.getElementById('zalo-messages-container');
    zaloMessageList = document.getElementById('zalo-message-list');
    openZaloBtn = document.getElementById('open-zalo-btn');
    closeZaloBtn = document.getElementById('close-zalo-view-btn');
    zaloVersionSpan = document.getElementById('zaloVersion');
    zaloSupportPhoneSpan = document.getElementById('zaloSupportPhone');
    zaloSupportNameSpan = document.getElementById('zaloSupportName');
    zaloNotificationModal = document.getElementById('zalo-notification-modal');
    zaloModalConfirmBtn = document.getElementById('zalo-modal-confirm-btn');

    appendLog("DOM Content Loaded! Starting application initialization.");

    function addNetworkStatusIndicator() {
        const styleHTML = `
            .network-status { width: 36px; height: 28px; display: flex; align-items: flex-end; justify-content: space-between; gap: 3px; }
            .network-status .signal-bar { flex-grow: 1; background-color: #e0e0e0; border-radius: 2px; transform-origin: bottom; transform: scaleY(0); transition: transform 0.3s ease-out, background-color 0.5s ease; }
            .network-status .signal-bar:nth-child(1) { height: 25%; transition-delay: 0s; }
            .network-status .signal-bar:nth-child(2) { height: 50%; transition-delay: 0.05s; }
            .network-status .signal-bar:nth-child(3) { height: 75%; transition-delay: 0.1s; }
            .network-status .signal-bar:nth-child(4) { height: 100%; transition-delay: 0.15s; }
            .network-status.good .signal-bar { transform: scaleY(1); background-color: #00d640; }
            .network-status.average .signal-bar:nth-child(-n+3) { transform: scaleY(1); background-color: #ffc107; }
            .network-status.poor .signal-bar:nth-child(1) { transform: scaleY(1); background-color: #dc3545; }
        `;

        const styleContainer = document.createElement('style');
        styleContainer.innerHTML = styleHTML;
        document.head.appendChild(styleContainer);

        const header = document.querySelector('#webrtc-call-popup .popup-header');
        if (header) {
            const indicatorHTML = `<div id="network-status" class="network-status" title="Đang kiểm tra chất lượng mạng..."><div class="signal-bar"></div><div class="signal-bar"></div><div class="signal-bar"></div><div class="signal-bar"></div></div>`;
            const oldIndicator = header.querySelector('.network-status');
            if (oldIndicator) {
                oldIndicator.remove();
            }
            header.insertAdjacentHTML('afterbegin', indicatorHTML);
        }
    }

    function addContactListStyles() {
        const styleHTML = `
            #contacts { max-height: 420px; overflow-y: auto; padding-right: 5px; }
            .contact-group { border-bottom: 1px solid #eee; }
            .contact-item.expandable { position: relative; }
            .contact-item.expandable .contact-name { flex-grow: 1; }
            .expand-icon { width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-left: auto; }
            .expand-icon svg { width: 18px; height: 18px; transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1); }
            .expand-icon svg path { stroke: #6c757d; stroke-width: 2; stroke-linecap: round; transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1); }
            .contact-group.expanded .expand-icon svg { transform: rotate(135deg); }
            .contact-group.expanded > .contact-item { background-color: #f8f9fa; border-radius: 6px 6px 0 0; }
            .sub-contact-list { max-height: 0; overflow: hidden; transition: max-height 0.3s ease-in-out; background-color: #f8f9fa; margin: 0 5px; border-radius: 0 0 6px 6px; }
            .contact-group.expanded .sub-contact-list { max-height: 500px; }
            .sub-contact-item { display: flex; align-items: center; gap: 10px; padding: 12px 10px 12px 60px; cursor: pointer; border-top: 1px solid #e9ecef; opacity: 0; transform: translateY(-10px); animation: sub-item-slide-in 0.3s ease-out forwards; }
            .sub-contact-item:hover { background-color: #e2e6ea; }
            .sub-contact-icon { width: 18px; height: 18px; filter: invert(40%); }
            @keyframes sub-item-slide-in { to { opacity: 1; transform: translateY(0); } }
        `;
        const styleContainer = document.createElement('style');
        styleContainer.innerHTML = styleHTML;
        document.head.appendChild(styleContainer);
    }
    addContactListStyles();
    addNetworkStatusIndicator();
    setupTransferModal();
    
    if (window.innerWidth < 800) {
        if(contactListContainer) contactListContainer.style.display = 'none';
        if(callControlContainer) callControlContainer.style.display = 'none';
        if(appContainer) appContainer.style.display = 'none';
    }

    try {
        const canvasElement = document.getElementById('background-canvas');
        if (canvasElement) {
            initCanvasBackground();
            appendLog("Hiệu ứng nền đã được khởi tạo.");
        }

        voip24hModuleInstance = Voip24hModule.getInstance('all');
        await voip24hModuleInstance.initializeModule();
        appendLog("Module WebRTC đã được khởi tạo thành công.");

        if (voip24hModuleInstance) {
            voip24hModuleInstance._handleJanusDestroyed = function() {
                appendLog("Janus session destroyed. Ignored page reload to prevent loop.");
            };
        }

        setupEventListeners();
        setupSecurityFeatures();

        const versionCheckUrl = `${WORKER_BASE_URL}/dial`;
        const formData = new URLSearchParams({ token: 'initial_version_check', phone: '0000000000' });
        const response = await fetch(versionCheckUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData
        });
        const responseData = await response.json();
        if (responseData.version) { updateVersionDisplay(responseData.version); } else { updateVersionDisplay('1.3.X (Lỗi tải)'); }
        if (responseData.supportPhone && responseData.supportPersonName) { updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName); } else { updateSupportInfoDisplay('N/A', 'N/A'); }
        appendLog("Thông tin phiên bản và hỗ trợ đã được tải.");

        const savedToken = localStorage.getItem(SAVED_TOKEN_KEY);
        if (savedToken) {
            appendLog(`Tìm thấy token đã lưu: ${savedToken}. Đang xác thực...`);
            savedActualToken = savedToken;
            unlockAudioContext();
            const tokenValid = await validateAndSetToken(savedToken, true);
            if (!tokenValid) {
                appendLog("Token đã lưu không hợp lệ hoặc IP bị hạn chế khi tải.");
            }
        } else {
            appendLog("Không tìm thấy token đã lưu. Đang hiển thị màn hình nhập token.");
            if(tokenEntryContainer) {
                tokenEntryContainer.style.display = 'block';
                tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
            }
            if(mainContentContainer) mainContentContainer.style.display = 'none';
            displayStatus('Vui lòng nhập token máy nhánh.', '', 5000, tokenStatusDiv);
        }

        setupAutoRefresh();
        appendLog("Chức năng tự động làm mới trang đã được thiết lập.");

    } catch (error) {
        appendLog(`Lỗi nghiêm trọng khi khởi tạo ứng dụng: ${error}`);
        console.error("Lỗi nghiêm trọng khi khởi tạo ứng dụng:", error);
        if (logContainer) logContainer.style.display = 'block';
        displayStatus(`Lỗi khởi tạo ứng dụng: ${error.message}. Vui lòng kiểm tra console log.`, 'error', 0, tokenStatusDiv);
    }
});
